import React, { useCallback } from 'react';
import "../../styles/home/view_cast.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCast, getItem } from "../repositories/movies_and_tvseries";
import ViewCastDetails from "./view_cast_details";

import noImage from "../../images/collections/no_image.png";
import searchIcon from "../../images/chats/search_icon.png";

const ViewCast = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [getSearch, setSearch] = useState("");
    const [getItemName, setItemName] = useState("");
    const [getCastId, setCastId] = useState("");
    const [getCastDetails, setCastDetails] = useState([]);
    const [getOriginalCastDetails, setOriginalCastDetails] = useState([]);
    const [getOnShowCastDetails, setOnShowCastDetails] = useState(false);

    const path = location.pathname.split("/");
    const type = path[path.indexOf("home") + 1]
    const itemId = path.pop();

    const goBack = () => {
        navigate(-1);
    };

    const onChangeSearch = (search) => {
        setSearch(search.target.value);
    };

    const onSetCastId = (id) => {
        setOnShowCastDetails(true);
        setCastId(id);
    };

    const retrieveItemDetails = async () => {
        const details = await getItem({itemId, type: type === "movie" ? type : "tv"});
        if (type === "movie") {
            setItemName(details["original_title"] === "" || details["original_title"] == null ? `Unable to retrieve the title of this ${type}` : details["original_title"]);
        } else {
            setItemName(details["original_name"] === "" || details["original_name"] == null ? `Unable to retrieve the title of this ${type}` : details["original_name"]);
        }
    }

    const retrieveCastDetails = useCallback(async () => {
        let newCastList = [];
        const castDetails = await getCast({itemId, type: type === "movie" ? type : "tv"});
        castDetails["cast"].forEach((cast) => {
            const isDuplicate = newCastList.some(item => item.id === cast.id);
            if (!isDuplicate) {
                if (cast.known_for_department === "Acting") {
                    newCastList.push({
                        id: cast.id,
                        name: cast.original_name,
                        character: cast.character,
                        image: cast.profile_path,
                        department: cast.known_for_department,
                    });
                } else {
                    newCastList.push({
                        id: cast.id,
                        name: cast.original_name,
                        image: cast.profile_path,
                        department: cast.known_for_department,
                        character: cast.job,
                    });
                }
            }
        });

        castDetails["crew"].forEach((cast) => {
            const isDuplicate = newCastList.some(item => item.id === cast.id);
            if (!isDuplicate) {
                if (cast.known_for_department === "Acting") {
                    newCastList.push({
                        id: cast.id,
                        name: cast.original_name,
                        character: cast.character,
                        image: cast.profile_path,
                        department: cast.known_for_department,
                    });
                } else {
                    newCastList.push({
                        id: cast.id,
                        name: cast.original_name,
                        image: cast.profile_path,
                        department: cast.known_for_department,
                        character: cast.job,
                    });
                }
            }
        });

        setCastDetails(newCastList);  
        setOriginalCastDetails(newCastList);    
    }, [itemId, type]);

    const getCardSpace = useCallback(() => {
        const parent = document.getElementById('home_view_cast_i');
        const parentWidth = parent.offsetWidth;
        const childWidth = window.innerWidth <= 600 ? 120 : 150 + 30;
        const numChildren = Math.floor(parentWidth / childWidth);
        parent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;
    }, []);
    
    useEffect(() => {
        getCardSpace();
        const handleResize = () => {
            getCardSpace();
        };
        
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [getCardSpace]);

    useEffect(() => {
        const filteredList = getOriginalCastDetails.filter((item) => {
            const isNameMatch = item.name && item.name.toLowerCase().includes(getSearch.toLowerCase());
            const isCharacterMatch = item.character && item.character.toLowerCase().includes(getSearch.toLowerCase());
            return isNameMatch || isCharacterMatch;
        });

        setCastDetails(filteredList);
    }, [getSearch, getOriginalCastDetails]);

    useEffect(() => {
        const parent = document.getElementById('home_view_cast_i');
        if (getCastDetails.length < 1) {
            parent.style.display = "flex";
            parent.style.flexDirection = "column";
            parent.style.alignItems = "center";
        } else if (getCastDetails.length > 0) {
            parent.style.display = "grid";
            parent.style.width = "100%";
        }
    }, [getCastDetails]); 

    useEffect(() => {
        if (getCastDetails && getCastDetails.length > 0) {
            getCastDetails.forEach((cast, index) => {
                const card = document.querySelectorAll(".home_view_cast_card")[index];
                if (cast.department !== "Acting") {
                    if (card) {
                        card.style.backgroundColor = "#03282a";
                    }
                }
            });
                
        }
    }, [getCastDetails]);
    
    useEffect(() => {
        retrieveItemDetails();
        retrieveCastDetails();
    }, []);   

    return(
        <div className="home_view_cast">
            <div className="home_view_cast_head_container">
                <p className="home_view_cast_title">{getItemName}</p>
                <p onClick={goBack} className="home_view_cast_back">back</p>
            </div>

            <div className="home_view_cast_search_input_container_i">
                <div className="home_view_cast_search_input_container">
                    <img alt='search' src={searchIcon} className="home_view_cast_search_input_icon"/>
                    <input className="home_view_cast_search_input_field" id="item_section_search" placeholder={`Search for any cast or crew...`} type="text" value={getSearch} onChange={onChangeSearch} />
                </div>
            </div>
            <div className="home_view_cast_divider"></div>

            <div className="home_view_cast_items_container">
                <div id="home_view_cast_i" className="home_view_cast_i">
                    {
                        getCastDetails.length > 0
                        ? getCastDetails.map((cast, index) => (
                            <div key={index} id="home_view_cast_card" onClick={() => onSetCastId(cast.id)} className="home_view_cast_card">
                                <img alt='cast' src={cast.image === "" || cast.image === null ? noImage : `https://image.tmdb.org/t/p/w500${cast.image}`} className="home_view_item_cast_card_image" />
                                <div className="home_view_cast_card_title">
                                    <p className="home_view_cast_card_character">{cast.character}</p>
                                    <p className="home_view_cast_card_name">{cast.name}</p>
                                </div>
                            </div>
                        ))
                        : <p className="home_view_cast_row_error">Unable to get the cast or crew of {getItemName} based your search.</p>
                    }
                </div>
            </div>

            {
                getCastId !== "" || getCastId !== null
                ? <ViewCastDetails getShow={getOnShowCastDetails} setShow={setOnShowCastDetails} getCastId={getCastId} />
                : null
            }
        </div>
    );
};

export default ViewCast;